import { WidgetRegistry } from "@Widgets/types";
import { CalculationModalWithToggle } from "../Components/Payments/CalculationModalWithToggle/CalculationModalWithToggle";

const serviceOffersWidgetRegistry: Pick<
  WidgetRegistry,
  "ServiceOffers.Payments.CalculationModalWithToggle"
> = {
  "ServiceOffers.Payments.CalculationModalWithToggle": {
    Component: CalculationModalWithToggle,
  },
};

export default serviceOffersWidgetRegistry;
